export const messages = {
  en: {
    adminEquipment: {
      search: {
        title: 'Search Conditions',
        machineName: 'Machine Name',
        machineCode: 'Machine Code',
        state: 'Select Status',
        importanceLevel: 'Select Importance Level'
      },
      table: {
        machineName: 'Machine Name',
        machineCode: 'Machine Code',
        brand: 'Machine Brand',
        model: 'Machine Model',
        locationDetail: 'Location Detail',
        firstEnableTime: 'First Enable Time',
        warrantyDeadline: 'Warranty Deadline',
        usefulLife: 'Useful Life',
        levelName: 'Importance Level',
        stateName: 'Status',
        purchasePrice: 'Purchase Price',
        netWorth: 'Net Worth'
      },
      statusTip: 'Equipment status is divided into: in use, disabled, etc.',
      fetchError: 'Failed to fetch equipment list'
    }
  },
  zh: {
    adminEquipment: {
      search: {
        title: '查询条件',
        machineName: '设备名称',
        machineCode: '设备编码',
        state: '请选择状态',
        importanceLevel: '请选择重要等级'
      },
      table: {
        machineName: '设备名称',
        machineCode: '设备编码',
        brand: '设备品牌',
        model: '设备型号',
        locationDetail: '位置详情',
        firstEnableTime: '首次启用时间',
        warrantyDeadline: '保修截止日期',
        usefulLife: '使用年限',
        levelName: '重要等级',
        stateName: '使用状态',
        purchasePrice: '采购价格',
        netWorth: '资产净值'
      },
statusTip: '设备状态分为：使用中，停用中 等状态',
      fetchError: '获取设备列表失败'
    }
  },
  'zh-TW': {
    adminEquipment: {
      search: {
        title: '查詢條件',
        machineName: '設備名稱',
        machineCode: '設備編碼',
        state: '請選擇狀態',
        importanceLevel: '請選擇重要等級'
      },
      table: {
        machineName: '設備名稱',
        machineCode: '設備編碼',
        brand: '設備品牌',
        model: '設備型號',
        locationDetail: '位置詳情',
        firstEnableTime: '首次啟用時間',
        warrantyDeadline: '保修截止日期',
        usefulLife: '使用年限',
        levelName: '重要等級',
        stateName: '使用狀態',
        purchasePrice: '採購價格',
        netWorth: '資產淨值'
      },
      statusTip: '設備狀態分為：使用中，停用中 等狀態',
      fetchError: '獲取設備列表失敗'
    }
  }
}